import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/settings` on its own opens the first tab there is. */
export const Route = createFileRoute('/_app/_org/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/organisation', replace: true })
  },
})
